// Added by Sejune Oh on 2020-04-21
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react';
import {
    ListItem as MaterialUIListItem,
    ListItemProps as MaterialUIListItemProps
} from '@material-ui/core'

interface ListItemBaseProps { }
export type ListItemProps = Partial<MaterialUIListItemProps> & ListItemBaseProps

export const ListItem: FC<ListItemProps> = ({ ...rest }) => {
    // @ts-ignore
    return <MaterialUIListItem {...rest}></MaterialUIListItem>
}
